module.exports = __webpack_public_path__ + "static/media/landing-soon.ced289f8.svg";